import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad, CampoProvincia } from '../components/';


interface IInputProvinciaProps extends Dati.IBaseProps {
    Etichetta: any;
    Valore: string;
    Comune?: string;
    CAP?: string;
}

export class InputProvincia extends BasePureComponent<IInputProvinciaProps, {}> {
    constructor(props: any) {
        super(props);
    }

    public render() {
        let etichetta: any = "";
        if (typeof (this.props.Etichetta == "string") && this.props.Etichetta != "") {
            etichetta = <label>{this.props.Etichetta}</label>;
        } else {
            etichetta = this.props.Etichetta;
        }
        return <div style={{ minHeight: 88 }} className={this.props.CSS != undefined ? this.props.CSS : ""}>
            {etichetta}
            <div className="kt-input-icon kt-input-icon--right">
                <CampoProvincia Id={this.props.Id} Name={this.props.Name} Valore={this.props.Valore} OnChange={this.props.OnChange} OnBlur={this.props.OnBlur} Comune={this.props.Comune} CAP={this.props.CAP} />
            </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/InputProvincia.tsx